<div class="admin-container container-fluid cxone-ui">
    <div class="row">
        <div class="col-12 d-flex justify-content-between">
            <div class="font-size-18 admin-title legacy-openSans-headline-h3" cvLocalizedText langSection="Admin" langKey="Admin_Page_Title">Admin
            </div>
        </div>
    </div>

    <div class="admin-tabs-container">
        <div id="admin-tabs-hover-container" *ngIf="isLoadingSavingProcess"></div>
        <sol-tabs #adminTabs class="cv-admin-tabs" [selectedIndex]="0" size="extraLarge" (selectedTabChange)="onTabChanged($event)">
            <ng-container *ngFor="let tab of tabList">
                <ng-container [ngSwitch]="tab.name">
                    <ng-container *ngSwitchCase="tabType.GAMES">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.GAMES">
                            <page-error-state *ngIf="!isDataLoading" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission" pageName="Games"></page-error-state>
                            <cv-games-landing *ngIf="selectedTab === tabType.GAMES && hasPermission && !noPMLicense" [isCxone]="isCxone"></cv-games-landing>
                        </sol-tab>
                    </ng-container>
                    <ng-container *ngSwitchCase="tabType.CHALLENGES">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.CHALLENGES">
                            <page-error-state *ngIf="!isDataLoading" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission" pageName="Challenges"></page-error-state>
                            <cv-admin-challenge *ngIf="selectedTab === tabType.CHALLENGES && hasPermission && !noPMLicense"></cv-admin-challenge>
                        </sol-tab>
                    </ng-container>
                    <ng-container *ngSwitchCase="tabType.AWARDS">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.AWARDS">
                            <page-error-state *ngIf="!isDataLoading" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission" pageName="Awards"></page-error-state>
                            <cv-awards-landing *ngIf="selectedTab === tabType.AWARDS && hasPermission && !noPMLicense" [isCxone]="isCxone" class="h-100 d-block overflow-auto"></cv-awards-landing>
                        </sol-tab>
                    </ng-container>
                    <ng-container *ngSwitchCase="tabType.BUDGET">
                        <sol-tab [title]="tab.localizedName" [ariaLabel]="tabType.BUDGET">
                            <page-error-state *ngIf="!isDataLoading" [noPMLicense]="noPMLicense" [noPermission]="!hasPermission" pageName="Budget"></page-error-state>
                            <cv-admin-budget *ngIf="selectedTab === tabType.BUDGET && hasPermission && !noPMLicense" class="h-100 d-block overflow-auto cxone-tab-landing"></cv-admin-budget>
                        </sol-tab>
                    </ng-container>
                </ng-container>
            </ng-container>
        </sol-tabs>
    </div>
</div>
